import { useGetMemberPrimaryTeamSuspenseQuery } from "#features/smart-reports/api/useGetMemberPrimaryTeamSuspenseQuery.ts";
import { Flex, HelperMessage, type HelperMessageProps, Link, Text } from "@hopper-ui/components";
import { useEnvironmentVariables, useGetCurrentUserSuspenseQuery, useSharedTranslation, useTracking } from "@workleap-ai/shared";
import { MixpanelEvent } from "@workleap-ai/shared/types";
import { useCallback } from "react";

type SmartReportsTeamInfoProps = Pick<HelperMessageProps, "padding" | "paddingX" | "paddingY" | "margin" | "marginX" | "marginTop" | "marginBottom">;

export const SmartReportsTeamInfo = ({
    padding,
    paddingX,
    paddingY,
    margin,
    marginX,
    marginTop,
    marginBottom
}: SmartReportsTeamInfoProps) => {
    const { tShared } = useSharedTranslation();
    const { data: primaryTeamName } = useGetMemberPrimaryTeamSuspenseQuery();
    const { data: { organizationName } } = useGetCurrentUserSuspenseQuery();
    const { managementAppBaseUrl } = useEnvironmentVariables();
    const { trackEvent } = useTracking();

    const handleChangeTeamClick = useCallback(() => {
        trackEvent(MixpanelEvent.ButtonClicked, {
            Location: "Smart Reports List",
            Trigger: "Change Team"
        });
    }, [trackEvent]);

    return (
        <HelperMessage
            backgroundColor="neutral-weakest"
            padding={padding}
            paddingX={paddingX}
            paddingY={paddingY}
            marginX={marginX}
            margin={margin}
            marginTop={marginTop}
            marginBottom={marginBottom}
            borderRadius="rounded-md"
            UNSAFE_gap=".75rem"
            width="100%"
        >
            <Flex direction="column" gap="inline-sm">
                <Text>{tShared("smartReports.description")}</Text>
                <Text>
                    {tShared("smartReports.generatedForTeam", { teamName: primaryTeamName ?? organizationName })}{" "}
                    <Link
                        href={`${managementAppBaseUrl}/profile/preferences/officevibe`}
                        isExternal
                        onPress={handleChangeTeamClick}
                    >
                        {tShared("smartReports.changeTeam")}
                    </Link>
                </Text>
            </Flex>
        </HelperMessage>
    );
};
